
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.5059 7.24508L11.372 0.494963C10.577 -0.164763 9.42297 -0.164724 8.62797 0.494963L0.494062 7.24508C0.180078 7.50567 0 7.88914 0 8.29719V17.8514C0 19.036 0.963789 19.9998 2.14844 19.9998H17.8516C19.0362 19.9998 20 19.036 20 17.8514V8.29719C20 7.88918 19.8199 7.50571 19.5059 7.24508ZM18.8281 17.8514C18.8281 17.9698 18.8069 18.0833 18.7681 18.1884L12.8088 14.1045L18.8281 9.10926V17.8514ZM1.17188 17.8514V9.10926L7.19117 14.1045L1.23187 18.1884C1.19309 18.0833 1.17188 17.9698 1.17188 17.8514ZM16.4453 9.56387L10.6071 14.4089C10.2553 14.7008 9.74469 14.7008 9.39289 14.4089L3.55469 9.56387V8.78969C3.55469 8.682 3.6423 8.59438 3.75 8.59438H16.25C16.3577 8.59438 16.4453 8.682 16.4453 8.78969V9.56387ZM8.12883 14.8827L8.64457 15.3107C9.03727 15.6366 9.51863 15.7995 10 15.7995C10.4814 15.7995 10.9628 15.6366 11.3555 15.3107L11.8712 14.8827L17.6283 18.828H2.37172L8.12883 14.8827ZM9.37637 1.39676C9.55703 1.24684 9.77852 1.17188 10 1.17188C10.2215 1.17188 10.443 1.24684 10.6237 1.39676L18.4552 7.89594L17.604 8.60227C17.5123 7.9368 16.9403 7.42246 16.25 7.42246H3.75C3.05973 7.42246 2.48766 7.9368 2.39598 8.60227L1.54484 7.89594L9.37637 1.39676Z"}})])
          )
        }
      }
    